<template>
    <div class="callKeyPad">
        <div class="callKeyPad__input">
            <input v-model="allString" type="text" disabled>
        </div>
        <div class="callKeyPad__content">
            <div class="callKeyPad__box">
                <div
                    class="callKeyPad__button"
                    @click="handleKeyDown(1)"
                >
                    <div>1</div>
                    <span>&nbsp;</span>
                </div>
                <div
                    class="callKeyPad__button"
                    @click="handleKeyDown(2)"
                >
                    <div>2</div>
                    <span>A B C</span>
                </div>
                <div
                    class="callKeyPad__button"
                    @click="handleKeyDown(3)"
                >
                    <div>3</div>
                    <span>D E F</span>
                </div>
            </div>

            <div class="callKeyPad__box">
                <div
                    class="callKeyPad__button"
                    @click="handleKeyDown(4)"
                >
                    <div>4</div>
                    <span>G H I</span>
                </div>
                <div
                    class="callKeyPad__button"
                    @click="handleKeyDown(5)"
                >
                    <div>5</div>
                    <span>J K L</span>
                </div>
                <div
                    class="callKeyPad__button"
                    @click="handleKeyDown(6)"
                >
                    <div>6</div>
                    <span>M N O</span>
                </div>
            </div>

            <div class="callKeyPad__box">
                <div
                    class="callKeyPad__button"
                    @click="handleKeyDown(7)"
                >
                    <div>7</div>
                    <span>P Q R S</span>
                </div>
                <div
                    class="callKeyPad__button"
                    @click="handleKeyDown(8)"
                >
                    <div>8</div>
                    <span>T U V</span>
                </div>
                <div
                    class="callKeyPad__button"
                    @click="handleKeyDown(9)"
                >
                    <div>9</div>
                    <span>W X Y Z</span>
                </div>
            </div>

            <div class="callKeyPad__box">
                <div
                    class="callKeyPad__button"
                    @click="handleKeyDown('*')"
                >
                    <div>*</div>
                    <span>&nbsp;</span>
                </div>
                <div
                    class="callKeyPad__button"
                    @click="handleKeyDown(0)"
                >
                    <div>0</div>
                    <span>+</span>
                </div>
                <div
                    class="callKeyPad__button"
                    @click="handleKeyDown('#')"
                >
                    <div>#</div>
                    <span>&nbsp;</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VoiceOrVideoMixin from '../../mixins/voice-or-video';

export default {
    emits: ['change'],
    
    components: {

    },

    mixins: [
        VoiceOrVideoMixin,
    ],

    props: {
        value: { type: String, default: false, },
    },

    data: () => ({
        index: 0,
        currentKey: null,
        currentValue: '',
        allValue: '',
        timeOutApplyValue: null,
        keyPadData: {
            1: ['1'],
            2: ['2'],
            3: ['3'],
            4: ['4'],
            5: ['5'],
            6: ['6'],
            7: ['7'],
            8: ['8'],
            9: ['9'],
            0: ['0', '+'],
            '*': ['*'],
            '#': ['#'],
        },
    }),

    computed: {
        allString() {
            return `${this.allValue}${this.currentValue}`;
        },


    },

    watch: {
        value(value) {
            this.allValue = value;
        }
    },

    methods: {
        handleKeyDown(key) {
            if (this.currentKey !== key) {
                this.handleApply();
            }

            const data = this.keyPadData[key];
            this.currentKey = key;
            this.currentValue = data[this.index];

            if ((this.index + 1) >= data.length) {
                this.index = 0;
            } else {
                this.index++;
            }

            this.handleTimeoutApply();
        },

        handleApply() {
            clearTimeout(this.timeOutApplyValue);
            this.index = 0;
            this.allValue += this.currentValue;
            this.currentValue = '';

            this.$emit('change', this.allValue);
        },

        handleTimeoutApply() {
            clearTimeout(this.timeOutApplyValue);
            this.timeOutApplyValue = setTimeout(() => {
                if (window.connect) {
                    window.connect.sendDigits(this.currentValue);
                }
                this.index = 0;
                this.allValue += this.currentValue;
                this.currentValue = '';

                this.$emit('change', [this.currentValue, this.allValue]);
            }, 500);
        }
    },
};
</script>
